import { getLogger } from '../../util/logger';
import bureaucrat from '../../util/Bureaucrat';
import { processLicenses } from '../util/dataHelpers';
import routerPaths from '../util/routerPaths';
import { actions } from '../util/actions';

const logger = getLogger('providerUtils');

export const getTenantProfile = async (setData, routerHistory) => {
  try {
    logger.debug('getTenantProfile');
    const response = await bureaucrat.getTenantProfile();
    const data = {
      ...response,
      isLoggedIn: response.tenant !== undefined,
      loading: false,
    };
    data.tenant = processLicenses(data.tenant);

    setData(data);
  } catch (err) {
    setData({ isLoggedIn: false, apiError: err.message, loading: false });
    logger.error(err);
    routerHistory.push({ pathname: routerPaths.ERROR, state: { error: err } });
  }
};

export const acquireHybrid = async (setData, routerHistory, auth) => {
  try {
    logger.debug('acquireHybrid');
    const response = await bureaucrat.getHybridOptions();

    if (response) {
      if (response.action === actions.login) {
        logger.debug('not logged in, redirecting to login page');
        await auth.getTenantProfile();
        routerHistory.push({
          pathname: routerPaths.LOGIN,
          state: { from: routerHistory.location },
        });
      }

      setData(response);
    } else {
      setData(false);
    }
    return response;
  } catch (err) {
    setData(false);
    logger.error(err);
    routerHistory.push({ pathname: routerPaths.ERROR, state: { error: err } });
  }
  return null;
};

export const getPrompts = async (setData, routerHistory, auth) => {
  try {
    logger.debug('getPrompts');
    const defaultPromptsResponse = await bureaucrat.getDefaultPrompts();
    const tenantPromptsResponse = await bureaucrat.getTenantPrompts();

    if (defaultPromptsResponse.action || tenantPromptsResponse.action) {
      logger.debug('not logged in, redirecting to login page');
      await auth.getTenantProfile();
      routerHistory.push({
        pathname: routerPaths.LOGIN,
        state: { from: routerHistory.location },
      });
    }

    const data = {
      customPrompts: tenantPromptsResponse,
      defaultPrompts: defaultPromptsResponse,
    };

    setData(data);
  } catch (err) {
    logger.error(err);
    routerHistory.push({ pathname: routerPaths.ERROR, state: { error: err } });
  }
};

export const acquireSkypeData = async (setData) => {
  try {
    logger.debug('acquireData');
    const response = await bureaucrat.whatNext();
    logger.debug(response);
    if (response) {
      response.tenant = processLicenses(response.tenant);
      setData(response);
    } else {
      setData(false);
    }
  } catch (err) {
    setData({ error: err });
    logger.error(err);
  }
};
